module.exports = __webpack_public_path__ + "static/media/3.15.e2af1298.png";